export default __webpack_public_path__ + "static/media/1.785dda9e.png";